document.addEventListener("DOMContentLoaded",cnf_midorfull(), false);

function cnf_midorfull(){
  var CRTurl = new URL(window.location.href);
  var crt_size_base = CRTurl.searchParams.get("rf_szrng");
  var mid_crt_size_base = CRTurl.searchParams.get("mid_rf_szrng");
  if(crt_size_base != null){
    sgs_cllc_conf();
  }else if(mid_crt_size_base != null){
    mid_sgs_cllc_conf();
  };
};

function sgs_cllc_conf(){
  var prd_l = document.querySelectorAll(".collection .product-item.product-item--vertical");
  var CRTurl = new URL(window.location.href);
  var crt_size_base = CRTurl.searchParams.get("rf_szrng");
  if(crt_size_base != null){
    var prd_l = document.querySelectorAll(".collection .product-list .product-item.product-item--vertical");
    for(var a = 0;a < prd_l.length;a++){
      var prd_hndl = prd_l[a].querySelectorAll("a.product-item__title")[0].getAttribute("href");
      if(prd_hndl.indexOf("_dps") > -1){
        var pr_pn = crt_size_base.split("_*_");
        var ref_sz_min = parseInt(pr_pn[0].split("-")[0]);
        var ref_sz_max = parseInt(pr_pn[0].split("-")[1]);
        var ref_sz = parseInt(prd_l[a].querySelectorAll("a.product-item__title")[0].textContent.split(" (")[1].split("L)")[0]);
        if(Number.isInteger(ref_sz)){
          if(ref_sz_min > ref_sz || ref_sz_max < ref_sz ){
            prd_l[a].setAttribute("style","display:none!important;");
          };
        }else{
          prd_l[a].setAttribute("style","display:none!important;");
        };
      }else{
        prd_l[a].setAttribute("style","display:none!important;");
      };
    };
    var tg = window.location.href.split("/collections/srt_ref_cllc/")[1].split("?")[0];
    if(tg != ""){var tg = tg.split("+").join("_*_");}
    if(pr_pn.length > 2){
      var pn = "/collections/sgs_prd_ref?sgs_pdd=" + pr_pn[1] + "_,_" + tg + "_,_" + pr_pn[0] + "_,_" + pr_pn[2]
    }else{
      var pn = "/collections/sgs_prd_ref?sgs_pdd=" + pr_pn[1] + "_,_" + tg + "_,_" + pr_pn[0]
    };
    document.querySelectorAll(".sgs_prd_back")[0].setAttribute("href",pn);
    document.querySelectorAll(".sgs_prd_back")[0].setAttribute("data-sgs_pb_dsp",true);
  };
};


function mid_sgs_cllc_conf() {
  var prd_l = document.querySelectorAll(".collection .product-item.product-item--vertical");
  var CRTurl = new URL(window.location.href);
  var crt_size_base = CRTurl.searchParams.get("mid_rf_szrng");
  if(crt_size_base != null){
    var prd_l = document.querySelectorAll(".collection .product-list .product-item.product-item--vertical");
    for(var a = 0;a < prd_l.length;a++){
      var prd_hndl = prd_l[a].querySelectorAll("a.product-item__title")[0].getAttribute("href");
      if(prd_hndl.indexOf("_dps") > -1){
        var pr_pn = crt_size_base.split("_;")[0].split("_");
        var ref_sz_min = parseInt(pr_pn[0].split("-")[0]);
        var ref_sz_max = parseInt(pr_pn[0].split("-")[1]);
        var ref_sz = parseInt(prd_l[a].querySelectorAll("a.product-item__title")[0].textContent.split(" (")[1].split("L)")[0]);
        if(Number.isInteger(ref_sz)){
          if(ref_sz_min > ref_sz || ref_sz_max < ref_sz ){
            prd_l[a].setAttribute("style","display:none!important;");
          };
        }else{
          prd_l[a].setAttribute("style","display:none!important;");
        };
      }else{
        prd_l[a].setAttribute("style","display:none!important;");
      };
    };
    var tg = window.location.href.split("/collections/srt_ref_cllc/")[1].split("?")[0];
    if(tg != ""){var tg = tg.split("+").join("*");};
    if(pr_pn.length > 2){
      var pn = "/collections/sgs_prd_ref?sgs_pdd_mid=" + pr_pn[1] + "-;" + tg + "-;" + pr_pn[0] + "-;" + pr_pn[2] + "_;" + crt_size_base.split("_;")[1];
    }else{
      var pn = "/collections/sgs_prd_ref?sgs_pdd_mid=" + pr_pn[1] + "-;" + tg + "-;" + pr_pn[0] + "_;" + crt_size_base.split("_;")[1];
    };
    document.querySelectorAll(".sgs_prd_back")[0].setAttribute("href",pn);
    document.querySelectorAll(".sgs_prd_back")[0].setAttribute("data-sgs_pb_dsp",true);
  };
};